import {
  AUTH_USER_LOGIC_PATHS,
  BOOKING_LOGIC_PATHS,
  OFFERS_LOGIC_PATHS,
  PATHS,
} from '@/constants/routes';

import shallow from 'zustand/shallow';
import { useRouteHandler } from '../state';
import { useRouter } from 'next/router';

// this hook is used to update path after (change city, login and logout)

interface UpdatePathModel {
  updateChangeCityPath: () => void;
  updateLoginPath: () => void;
  updateLogoutPath: () => void;
}

type UseUpdatePathFunc = () => UpdatePathModel;

export const useUpdatePath: UseUpdatePathFunc = () => {
  const router = useRouter();

  const routeHandler = useRouteHandler(s => s.routeHandler, shallow);

  const navigateTo = (targetUrl: string) => {
    routeHandler?.removeOnRouteChangeStartListener?.();
    router.push(targetUrl);
  };

  const updateChangeCityPath = () => {
    if (router.pathname === PATHS.CINEMA_SLUG) {
      navigateTo(PATHS.CINEMAS);
    } else if (router.pathname === PATHS.EXPERIENCES_SLUG) {
      navigateTo(PATHS.EXPERIENCES);
    } else if (OFFERS_LOGIC_PATHS.includes(router.pathname as PATHS)) {
      navigateTo(PATHS.OFFERS);
    } else if (BOOKING_LOGIC_PATHS.includes(router.pathname as PATHS)) {
      navigateTo(PATHS.HOME);
    }
  };

  const updateLoginPath = () => {
    if (router.pathname === PATHS.CINEMA_SLUG) {
      navigateTo(PATHS.CINEMAS);
    } else if (router.pathname === PATHS.EXPERIENCES_SLUG) {
      navigateTo(PATHS.EXPERIENCES);
    } else if (OFFERS_LOGIC_PATHS.includes(router.pathname as PATHS)) {
      navigateTo(PATHS.OFFERS);
    } else if (
      [PATHS.MOVIES_SLUG, PATHS.BOOKINGS_ID_YOUR_TICKET].includes(
        router.pathname as PATHS
      )
    ) {
      navigateTo(PATHS.HOME);
    }
  };

  const updateLogoutPath = () => {
    if (router.pathname === PATHS.CINEMA_SLUG) {
      navigateTo(PATHS.CINEMAS);
    } else if (router.pathname === PATHS.EXPERIENCES_SLUG) {
      navigateTo(PATHS.EXPERIENCES);
    } else if (OFFERS_LOGIC_PATHS.includes(router.pathname as PATHS)) {
      navigateTo(PATHS.OFFERS);
    } else if (
      [
        ...AUTH_USER_LOGIC_PATHS,
        ...BOOKING_LOGIC_PATHS,
        PATHS.BOOKINGS_ID_YOUR_TICKET,
      ].includes(router.pathname as PATHS)
    ) {
      navigateTo(PATHS.HOME);
    }
  };

  return {
    updateChangeCityPath,
    updateLoginPath,
    updateLogoutPath,
  };
};
